module.exports= {
    "postbox-text": "Sem napíšte svoj komentár (minimálne 3 znaky)",
    "postbox-author": "Meno (nepovinné)",
    "postbox-email": "E-mail (nepovinný)",
    "postbox-website": "Web (nepovinný)",
    "postbox-preview": "Náhľad",
    "postbox-edit": "Upraviť",
    "postbox-submit": "Publikovať",
    "num-comments": "Jeden komentár\n{{ n }} komentáre\n{{ n }} komentárov",
    "no-comments": "Zatiaľ bez komentárov",
    "comment-reply": "Odpovedať",
    "comment-edit": "Upraviť",
    "comment-save": "Uložiť",
    "comment-delete": "Zmazať",
    "comment-confirm": "Potvrdit",
    "comment-close": "Zavrieť",
    "comment-cancel": "Zrušiť",
    "comment-deleted": "Komentár bol vymazaný",
    "comment-queued": "Komentár zaradený na schválenie",
    "comment-anonymous": "Anonym",
    "comment-hidden": "{{ n }} skrytý\n{{ n }} skryté\n{{ n }} skrytých",
    "date-now": "práve teraz",
    "date-minute": "pred minútou\npred {{ n }} minútami",
    "date-hour": "pred hodinou\npred {{ n }} hodinami",
    "date-day": "včera\npred {{ n }} dňami",
    "date-week": "minulý týždeň\npred {{ n }} týždňami",
    "date-month": "minulý mesiac\npred {{ n }} mesiacmi",
    "date-year": "minulý rok\npred {{ n }} rokmi"
};
